import * as Yup from 'yup';
import { l10nEnService } from '@uplift/services';
import { ForgotPasswordFormType } from '../reset-password-form.component';
import { useMemo } from 'react';

export const useForgotPasswordValidationSchema = (l10n: typeof l10nEnService): Yup.ObjectSchema<ForgotPasswordFormType> => {
  return useMemo(() => {
    return Yup.object().shape({
      email: Yup.string()
        .email(l10n.validations.invalidEmail)
        .required(l10n.validations.loginForm.emailBlank),
    });
  }, [ l10n.validations.invalidEmail, l10n.validations.loginForm.emailBlank ]);
};
